import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberSeparator',
})
export class NumberSeparatorPipe implements PipeTransform {
  transform(value: any): string {
    if (value === undefined || value === null) return '';
    return value.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
  }
}
